<script lang="ts">
	import { getContext } from "svelte";
	import { getSortConfig } from "@xbs/lib-kanban";
	import { uid } from "@xbs/lib-state";

	import type {
		IApi,
		TSortDir,
		ISortConfig,
		ISortItemOption,
	} from "@xbs/lib-kanban";
	import type { Writable } from "svelte/store";

	import Icon from "../Icon.svelte";
	import Menu from "../Menu.svelte";

	const _ = getContext<any>("wx-i18n").getGroup("kanban");

	export let api: IApi;
	export let options: ISortItemOption[] = null;

	$: {
		options = Array.isArray(options) ? options : getSortConfig();

		options.forEach(el => {
			el.id = el.id || (uid() as any);
			el.label = _(el.label);
			el.icon = el.dir === "asc" ? "wxi-asc" : "wxi-desc";
		});
	}

	let menuCoords = { x: 0, y: 0 };
	let iconEl: HTMLElement;
	$: {
		if (iconEl && menuOpen) {
			menuCoords = {
				x: iconEl.offsetLeft,
				y: iconEl.offsetTop + iconEl.offsetHeight,
			};
		}
	}

	let preserve = null;
	let stateSort: Writable<ISortConfig | null>;
	$: {
		if (!stateSort) {
			stateSort = api.getReactiveState()
				.sort as Writable<ISortConfig | null>;
		}
		if ($stateSort?.preserve) {
			preserve = options.find(
				el => el.by === $stateSort.by && el.dir === $stateSort.dir
			);
		} else {
			preserve = null;
		}
	}

	let menuOpen = false;
	function showMenu() {
		menuOpen = true;
	}

	function handleMenuAction(ev: any) {
		const action = ev?.detail.id;

		const sortRule = options.find(s => s.id === action);

		if (sortRule) {
			api.exec("set-sort", {
				by: sortRule.by,
				dir: sortRule.dir as TSortDir,
			});
		}
		menuOpen = false;
	}

	function handleReset() {
		api.exec("set-sort", null);
		menuOpen = false;
	}

</script>

{#if preserve}
	<div class="wx-preserve">
		<Icon name="wxi-close" click={handleReset} />
		{preserve.label}
	</div>
{/if}
<div
	class="wx-control"
	on:click={showMenu}
	title={_('Sort')}
	bind:this={iconEl}>
	<Icon name="wxi-sort" />
	{#if menuOpen}
		<Menu
			coords={menuCoords}
			data={options}
			on:click={handleMenuAction}
			container={document.querySelector('.wx-portal') || document.body}
			cancel={() => {
				menuOpen = null;
			}} />
	{/if}
</div>

<style>
	.wx-control {
		display: flex;
		justify-content: center;
		align-items: center;

		cursor: pointer;
		padding: 4px;
		margin-left: 4px;
		transition: background-color 0.2s ease-out;
	}
	.wx-control:hover {
		border-radius: var(--wx-input-border-radius);
		background-color: rgba(0, 0, 0, 0.07);
	}
	.wx-control:active {
		background-color: rgba(0, 0, 0, 0.15);
	}

	.wx-preserve {
		padding: 4px;
		padding-right: 8px;
		display: flex;
		align-items: center;
		background: var(--wx-kanban-background);
	}

</style>
